// =====================================================================
// CarteMotDePasse.jsx — cadre des pages « mot de passe oublié » (même aspect que ChangePassword.jsx)
// =====================================================================
export default function CarteMotDePasse({ titre, children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #eef2ff, #f5f3ff)', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 32, width: '100%', maxWidth: 460, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' }}>🔐 {titre}</h1>
        {children}
      </div>
    </div>
  );
}

export const styles = {
  texte: { color: '#64748b', fontSize: 13, marginTop: 6, marginBottom: 20, lineHeight: 1.5 },
  label: { display: 'block', fontSize: 12, color: '#475569', fontWeight: 600, marginBottom: 6 },
  champ: { width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' },
  erreur: { padding: 10, background: '#fee2e2', color: '#991b1b', borderRadius: 6, fontSize: 13, marginBottom: 12, border: '1px solid #fca5a5' },
  succes: { padding: 10, background: '#dcfce7', color: '#166534', borderRadius: 6, fontSize: 13, marginBottom: 12, border: '1px solid #86efac' },
  bouton: (actif) => ({
    width: '100%', padding: '12px 16px', borderRadius: 8, border: 'none', color: 'white', fontSize: 14, fontWeight: 600,
    background: actif ? 'linear-gradient(135deg, #4f46e5, #6366f1)' : '#94a3b8', cursor: actif ? 'pointer' : 'wait',
  }),
  lien: { display: 'inline-block', marginTop: 16, fontSize: 13, color: '#4f46e5' },
};
